import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();
        this.setState({active: false});
    }

    render({logged_in, state_upc, power_upc, packages, sale_price_code}, {active}) {
        const className = (state_upc == power_upc) ? 'active' : null;
        const selected_package = packages.filter((pkg) => pkg.upc == power_upc)[0] || packages[0];
        const coins = (selected_package.paid_kcs + selected_package.free_kcs);
        const price = selected_package.usd.current;

        let ga_label = 'logged-out';
        if (logged_in) {
            ga_label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
        }

        return (
            <pseudo-select class={className} active={active} onclick={(e) => this.trackFocus(e, ga_label)}>
                <h4>{coins} <span>Karma Coins</span></h4>
                <h6>${price}</h6>
                <ul active={active}>
                    { packages.map((pkg) => (this.renderListItem(pkg, ga_label))) }
                </ul>
            </pseudo-select>
        );
    }

    renderListItem(pkg, ga_label) {
        return (
            <li onClick={(e) => this.trackChange(e, pkg.upc, ga_label)}>
                <h4>{pkg.paid_kcs + pkg.free_kcs} <span>Karma Coins</span></h4>
                <h6>${pkg.usd.current}</h6>
            </li>
        );
    }

    trackChange(e, upc, ga_label) {
        e.stopPropagation();
        this.setState({active: false});
        this.props.trackChange(upc, ga_label);
        this.props.setPowerUPC(upc);
    }

    trackFocus(e, ga_label) {
        if (!this.state.active) {
            this.props.trackFocus(ga_label);
        }

        this.setState({active: !this.state.active});
    }

    setPowerValue(upc) {
        this.props.setPowerUPC(upc);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    state_upc: state['karmacoin-store'].upc,
    power_upc: state['karmacoin-store'].power_upc,
    packages: state['karmacoin-store'].packages.power,
    sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code,
});

const mapDispatchToProps = (dispatch) => ({
    trackChange: (power_upc, ga_label) => dispatch({
        type: 'ga:event',
        payload: [
            'kc-store',
            'Click-' + power_upc,
            ga_label,
        ],
    }),
    trackFocus: (ga_label) => dispatch({
        type: 'ga:event',
        payload: [
            'kc-store',
            'Reveal-Power-Packages',
            ga_label,
        ],
    }),
    setPowerUPC: (power_upc) => dispatch({ type: 'karmacoin-store:power_upc', payload: power_upc }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/karmacoin-store/pseudo-select.js